__turbopack_context__.v({
  "replacementsContainer": "ProductIngredientsForm-module-scss-module__SCjyta__replacementsContainer",
});
